<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Lioness Rampant: Song of the Lioness, by Tamora Pierce." class="imagefp" role="doc-cover" src="e9781439132081/images/9781439132081.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?88c31f1e